import React from 'react';

/**
 * CalendarUser
 *
 * Simple svg icon.
 * As this is only for a temporal landing page it is not moved to DS.
 * Fixed mobile visibility: explicit dimensions with responsive scaling
 */
const CalendarUser = () => (
  <svg
    width="100%"
    height="99"
    viewBox="0 0 99 99"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      minWidth: '80px',
      minHeight: '80px',
      maxWidth: '120px',
      maxHeight: '120px',
    }}
  >
    <rect
      x="0.9375"
      y="0.5"
      width="97.125"
      height="97.125"
      rx="20.5625"
      fill="white"
    />
    <rect
      x="0.9375"
      y="0.5"
      width="97.125"
      height="97.125"
      rx="20.5625"
      stroke="#0A1F44"
    />
    <g clipPath="url(#clip0_10348_3613)">
      <g clipPath="url(#clip1_10348_3613)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M60.3117 47.625C57.2757 47.625 54.8117 50.089 54.8117 53.125C54.8117 56.161 57.2757 58.625 60.3117 58.625C63.3477 58.625 65.8117 56.161 65.8117 53.125C65.8117 50.089 63.3477 47.625 60.3117 47.625ZM60.3117 50.375C61.8297 50.375 63.0617 51.607 63.0617 53.125C63.0617 54.643 61.8297 55.875 60.3117 55.875C58.7937 55.875 57.5617 54.643 57.5617 53.125C57.5617 51.607 58.7937 50.375 60.3117 50.375Z"
          fill="#0A1F44"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M55.0995 68.7083C57.8862 68.7083 62.75 68.7083 65.5367 68.6845C66.5652 68.6845 67.5405 68.1748 68.1363 67.3205C68.7322 66.4662 68.8715 65.3753 68.5122 64.3982C67.315 61.0413 64.0938 58.625 60.3117 58.625C56.535 58.625 53.3157 61.034 52.0873 64.3908C51.7243 65.3753 51.8655 66.4753 52.4668 67.3352C53.0663 68.1968 54.0508 68.7083 55.0995 68.7083ZM55.0995 65.9583C54.9492 65.9583 54.808 65.885 54.7218 65.7622C54.6357 65.6393 54.6155 65.4817 54.6668 65.3405C54.6687 65.3405 54.6687 65.3387 54.6687 65.3387C55.512 63.0342 57.7193 61.375 60.3117 61.375C62.9003 61.375 65.104 63.0287 65.9272 65.335C65.929 65.3405 65.929 65.346 65.9308 65.3497C65.9803 65.4835 65.962 65.632 65.8795 65.7475C65.7988 65.8648 65.6668 65.9345 65.5238 65.9345C65.5202 65.9345 65.5165 65.9345 65.5128 65.9345C62.7317 65.9583 57.8788 65.9583 55.0995 65.9583Z"
          fill="#0A1F44"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M65.0417 43.5V38.9166C65.0417 35.1198 61.9635 32.0416 58.1667 32.0416H36.1667C32.3699 32.0416 29.2917 35.1198 29.2917 38.9166V60.9166C29.2917 64.7135 32.3699 67.7916 36.1667 67.7916H47.1667C47.9257 67.7916 48.5417 67.1756 48.5417 66.4166C48.5417 65.6576 47.9257 65.0416 47.1667 65.0416C47.1667 65.0416 40.9664 65.0416 36.1667 65.0416C33.8879 65.0416 32.0417 63.1955 32.0417 60.9166V38.9166C32.0417 36.6378 33.8879 34.7916 36.1667 34.7916H58.1667C60.4455 34.7916 62.2917 36.6378 62.2917 38.9166V43.5C62.2917 44.259 62.9077 44.875 63.6667 44.875C64.4257 44.875 65.0417 44.259 65.0417 43.5Z"
          fill="#0A1F44"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M38 30.6666V36.1666C38 36.9256 38.616 37.5416 39.375 37.5416C40.134 37.5416 40.75 36.9256 40.75 36.1666V30.6666C40.75 29.9076 40.134 29.2916 39.375 29.2916C38.616 29.2916 38 29.9076 38 30.6666Z"
          fill="#0A1F44"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M53.5834 30.6666V36.1666C53.5834 36.9256 54.1994 37.5416 54.9584 37.5416C55.7174 37.5416 56.3334 36.9256 56.3334 36.1666V30.6666C56.3334 29.9076 55.7174 29.2916 54.9584 29.2916C54.1994 29.2916 53.5834 29.9076 53.5834 30.6666Z"
          fill="#0A1F44"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M38.0002 46.7083H43.6835C44.4425 46.7083 45.0585 46.0923 45.0585 45.3333C45.0585 44.5743 44.4425 43.9583 43.6835 43.9583H38.0002C37.2412 43.9583 36.6252 44.5743 36.6252 45.3333C36.6252 46.0923 37.2412 46.7083 38.0002 46.7083Z"
          fill="#0A1F44"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M47.3752 46.75H49.0585C49.8175 46.75 50.4335 46.134 50.4335 45.375C50.4335 44.616 49.8175 44 49.0585 44H47.3752C46.6162 44 46.0002 44.616 46.0002 45.375C46.0002 46.134 46.6162 46.75 47.3752 46.75Z"
          fill="#0A1F44"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M38 54.0416H47.1667C47.9257 54.0416 48.5417 53.4256 48.5417 52.6666C48.5417 51.9076 47.9257 51.2916 47.1667 51.2916H38C37.241 51.2916 36.625 51.9076 36.625 52.6666C36.625 53.4256 37.241 54.0416 38 54.0416Z"
          fill="#0A1F44"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M51.0002 54.0416H52.1669C52.9259 54.0416 53.5419 53.4256 53.5419 52.6666C53.5419 51.9076 52.9259 51.2916 52.1669 51.2916H51.0002C50.2412 51.2916 49.6252 51.9076 49.6252 52.6666C49.6252 53.4256 50.2412 54.0416 51.0002 54.0416Z"
          fill="#0A1F44"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_10348_3613">
        <rect
          width="40.125"
          height="40.125"
          fill="white"
          transform="translate(29.4375 29)"
        />
      </clipPath>
      <clipPath id="clip1_10348_3613">
        <rect
          width="40"
          height="40"
          fill="white"
          transform="translate(29 29)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default CalendarUser;
